import { render, staticRenderFns } from "./ModalSendArchive.vue?vue&type=template&id=78d02f6a&scoped=true"
import script from "./ModalSendArchive.vue?vue&type=script&lang=js"
export * from "./ModalSendArchive.vue?vue&type=script&lang=js"
import style0 from "./ModalSendArchive.vue?vue&type=style&index=0&id=78d02f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d02f6a",
  null
  
)

export default component.exports